import { bindingMode, customElement } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { bindable } from 'aurelia-typed-observable-plugin';

@customElement('application-bar')
export class ApplicationBarCustomElement {
  @bindable router: Router = null;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) menuToggled = false;

  toggleMenu() {
    this.menuToggled = !this.menuToggled;
  }
}
